import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import moment from 'moment'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import RowStack from 'components/atoms/container/RowStack'
import { Tag } from 'components/atoms/Text'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ROLE_PLAY, ROLE_PLAY_PRACTISES, ALL_SCENARIOS } from 'routes/constants'
import { ColStack } from 'components/atoms/container/InCardStack'

const RolePlayCard = ({
  data,
  setNewRolePlay = () => {},
  ...containerProps
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { title, summary, createdAt } = data

  const createdWeeksAgo = moment.utc().diff(moment.utc(createdAt), 'weeks')

  const onRolePlayPracticePath =
    location.pathname === ROLE_PLAY_PRACTISES ||
    location.pathname === ALL_SCENARIOS

  const navigateToRolePlay = () => {
    if (onRolePlayPracticePath) {
      navigate(ROLE_PLAY, {
        state: {
          rolePlayId: data.id
        }
      })
    } else {
      setNewRolePlay(data.id)
    }
  }

  return (
    <BoxWithBackground
      height={300}
      width={270}
      borderRadius={3}
      boxSizing='border-box'
      padding={10}
      paddingTop={12}
      boxShadow='0px 1px 15px 0px rgba(0, 0, 0, 0.10)'
      backgroundColor={theme.palette.background.paper}
      data-testid={`role-play-${data?.id}`}
      {...containerProps}>
      {createdWeeksAgo <= 6 && (
        <Box
          width='100%'
          height={16}
          paddingBottom={2}
          display='flex'
          justifyContent='center'
          sx={{
            position: 'absolute',
            top: 0,
            left: 0
          }}>
          <BoxWithBackground
            sx={{
              borderBottomRightRadius: 2,
              borderBottomLeftRadius: 2,
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0
            }}
            backgroundColor={colors.GoldenYellow400}
            paddingX={4}
            paddingY={2}
            margin={0}>
            <Typography variant='eyebrow' display='block' marginTop={-2}>
              {t('rolePlay.new')}
            </Typography>
          </BoxWithBackground>
        </Box>
      )}
      <ColStack justifyContent='space-between' height='100%' spacing={0}>
        <ColStack>
          <RowStack
            sx={{
              width: '100%',
              justifyContent: 'space-between'
            }}>
            <Tag>{data.virtue.name}</Tag>
            <Typography variant='h6'>5-15 {t('rolePlay.mins')}</Typography>
          </RowStack>
          <Stack padding={0} spacing={4} height={130}>
            <Typography variant='h4'>&ldquo;{title}&rdquo;</Typography>
            <Typography sx={{ overflowY: 'scroll' }}>{summary}</Typography>
          </Stack>
        </ColStack>
        <Button fullWidth={true} onClick={navigateToRolePlay}>
          {t('rolePlay.viewScenario')}
        </Button>
      </ColStack>
    </BoxWithBackground>
  )
}

export default RolePlayCard
